import { useQuery } from '@tanstack/react-query';
import { billingService } from '../services/billingService';
import { getPlanFeatures, normalizePlan } from '../lib/planFeatures';

// Reads the current user's plan entitlements. Shares the 'subscription-for-nav'
// query key with DashboardLayout so there is no extra network call.
export function usePlanFeatures() {
  const { data, isLoading } = useQuery({
    queryKey: ['subscription-for-nav'],
    queryFn: async () => {
      try {
        return await billingService.getSubscription();
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60 * 1000,
  });

  // `plan` is for copy that names the tier (upsells); gating should read
  // `features` so the entitlement stays in one place.
  return { features: getPlanFeatures(data?.planType), plan: normalizePlan(data?.planType), isLoading };
}
